export const meta = { id: 'O21', slug: 'gestao-formacoes', title: 'Conheça Gestão de Formações', description: 'Entenda a estrutura Formação → Etapas → Componentes → Participantes → Progresso → Conclusão.', profile: 'owner', category: 'formacoes', type: 'screen', status: 'published', order: 510, keywords: ['formações','etapas','componentes','participantes','progresso'], previous: 'O20', next: 'O22', related: ['O22','O23','O31','A06'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Conheça Gestão de Formações

Uma Formação é um programa estruturado de desenvolvimento que pode combinar diferentes experiências.

**Formação → Etapas → Componentes → Participantes → Progresso → Conclusão**

<Diagram kind="formation-structure" caption="A Formação organiza o programa, suas Etapas e Componentes e acompanha cada participante até a conclusão conforme as regras configuradas." />

<HelpImage pendingId="O21.1" alt="Tela de Gestão de Formações" />

## Status da Formação

Na versão atual, uma Formação pode passar por estados como **Rascunho**, **Publicada** e **Arquivada**.

<Callout type="concept">Formação não é apenas um Treinamento maior. Ela pode reunir aprendizagem, prática, evidências, Mentoria, checkpoints e outras experiências.</Callout>
